// Module
var code = "<td class=\"label\">{{label}}</td><td class=\"value\">{{value}}</td> ";
// Exports
export default code;